import * as Api from '@ViewModels';
import { LocationDescriptor } from 'history';
import { parse as getQueryStringParams } from 'query-string';
import * as React from 'react';
import { Redirect, RouteComponentProps, withRouter } from 'react-router-dom';
import { IUserSessionComponentProps } from '../../../models/AppState';
import { clearLaunchDarklyStorage } from '../../../models/LaunchDarklyStorage';
import { logoutAndClearCaches } from '../../../models/UiUtils';
import { ICredential } from '../../../viewmodels/AppViewModels';
import { LoadingSpinner } from '../../components/LoadingSpinner';
import { IMPERSONATION_INFO_KEY, type IImpersonationInfo } from './impersonation';

// Re-export for backwards compatibility
export { IMPERSONATION_INFO_KEY, type IImpersonationInfo } from './impersonation';

interface IProps<TUserSession extends Api.UserSessionContext = Api.UserSessionContext>
	extends RouteComponentProps<any>,
		IUserSessionComponentProps {
	redirection?: LocationDescriptor<any>;
	userSession: TUserSession;
}

interface IState {
	loading?: boolean;
}

class _CustomerSessionStart extends React.Component<IProps, IState> {
	public state: IState = {
		loading: true,
	};

	public componentDidMount() {
		const { location, userSession } = this.props;
		logoutAndClearCaches();

		const params = getQueryStringParams(location.search || '');
		const credential = params as ICredential;

		// Store impersonation tracking info for LaunchDarkly session metadata
		const isImpersonating = params.isImpersonated === 'true' || params.isImpersonated === true;
		if (isImpersonating) {
			const impersonationInfo: IImpersonationInfo = {
				isImpersonated: true,
				impersonatedByUserId: params.impersonatedByUserId as string,
				impersonatedByUserName: params.impersonatedByUserName as string,
			};
			sessionStorage.setItem(IMPERSONATION_INFO_KEY, JSON.stringify(impersonationInfo));
		} else {
			sessionStorage.removeItem(IMPERSONATION_INFO_KEY);
		}

		// Clear LaunchDarkly storage to prevent session correlation
		clearLaunchDarklyStorage();

		userSession.webServiceHelper.getCredentialStore().setCredential(credential);
		userSession.load()?.then(() => {
			this.setState({
				loading: false,
			});
		});
	}

	public render() {
		const { loading } = this.state;
		const { redirection } = this.props;
		if (loading) {
			return <LoadingSpinner type='login' />;
		}

		return <Redirect to={redirection} />;
	}
}

export const CustomerSessionStart = withRouter(_CustomerSessionStart);
